module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshData()
      }
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabItems), function(tabItem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_c('v-badge', {
      attrs: {
        "overlap": ""
      },
      scopedSlots: _vm._u([(_vm.enabledFilter['tab-' + n]) ? {
        key: "badge",
        fn: function() {
          return [_c('v-icon', {
            staticClass: "caption"
          }, [_vm._v("filter_list")])]
        },
        proxy: true
      } : null], null, true)
    }, [_vm._v(" "), _c('div', {
      staticClass: "pa-2"
    }, [_vm._v(_vm._s(tabItem + ' (' + _vm.totalTaskList[tabItem] + ')'))])])], 1)
  }), 1), _vm._v(" "), (_vm.lAction === 'view-task') ? _c('v-tabs-items', {
    on: {
      "change": function($event) {
        return _vm.refreshData()
      }
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabItems), function(tabItem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [_c('v-layout', {
      staticClass: "pa-0",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card-actions', {
      class: _vm.totalTaskList[tabItem] === 0 ? '' : 'pa-1'
    }, [(_vm.totalTaskList[tabItem] === 0 && !_vm.load) ? _c('div', {
      staticClass: "info--text text-xs-center pt-2"
    }, [_vm._v("No Tasks!")]) : _vm._e(), _vm._v(" "), (_vm.tab === 'tab-0' && _vm.totalTaskList[tabItem] > 0) ? _c('div', {
      staticClass: "px-2 py-0"
    }, _vm._l((_vm.filterList), function(curFilter, n) {
      return _c('span', {
        key: n
      }, [(_vm.filterStats.length > 0) ? _c('v-chip', {
        class: _vm.choosenFilter === curFilter ? 'primary white--text' : '',
        on: {
          "click": function($event) {
            return _vm.loadOpenTasks(curFilter)
          }
        }
      }, [_vm._v(_vm._s(curFilter + ' (' + _vm.filterStats.filter(function (rec) { return rec.stats === curFilter; })[0].total + ')'))]) : _vm._e()], 1)
    }), 0) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1)], 1), _vm._v(" "), (_vm.choosenView === 'card') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm7": "",
        "mx-auto": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.totalTaskList[tabItem] > 0) ? _c('v-expansion-panel', {
      staticClass: "px-2",
      attrs: {
        "value": _vm.selTab,
        "popout": ""
      }
    }, _vm._l(((_vm.tab === 'tab-0' ? _vm.subOpenTabItems : _vm.subClosedTabItems)), function(taskTitle, i) {
      return _c('v-expansion-panel-content', {
        key: i,
        staticClass: "align-baseline my-2"
      }, [_c('div', {
        staticClass: "px-0",
        attrs: {
          "slot": "header"
        },
        slot: "header"
      }, [(_vm.tasktabItems[taskTitle]) ? _c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(taskTitle + ' (' + _vm.tasktabItems[taskTitle].length + ')'))]) : _vm._e()]), _vm._v(" "), _c('v-card', {
        attrs: {
          "flat": ""
        }
      }, [_c('v-card-text', {
        staticClass: "pt-0"
      }, [_c('v-data-iterator', {
        attrs: {
          "items": _vm.tasktabItems[taskTitle],
          "hide-actions": ""
        },
        scopedSlots: _vm._u([{
          key: "item",
          fn: function(props) {
            return [_c('v-layout', [_c('v-flex', {
              staticClass: "pb-2",
              attrs: {
                "xs12": ""
              }
            }, [_c('v-card', {
              attrs: {
                "id": 'task_' + props.item.task_id
              }
            }, [_c('v-card-text', {
              staticClass: "py-0"
            }, [_c('v-layout', {
              attrs: {
                "row": "",
                "wrap": ""
              }
            }, [_c('v-flex', {
              staticClass: "pa-0",
              attrs: {
                "xs10": "",
                "sm11": ""
              }
            }, [(props.item.task_cat !== 'Project') ? _c('div', {
              staticClass: "pt-3 subheading"
            }, [_c('b', [_vm._v(_vm._s(props.item.task_cat + ' - ' + props.item.service)), (props.item.task_loc_id) ? _c('span', [_vm._v(" - " + _vm._s(props.item.task_loc))]) : _vm._e()]), _vm._v(" "), _c('span', {
              staticClass: "caption grey--text"
            }, [_vm._v(_vm._s('#' + props.item.task_id))])]) : _c('div', {
              staticClass: "pt-3 subheading"
            }, [_c('b', [_vm._v(_vm._s(props.item.task_cat + ' - ' + props.item.proj_name)), (props.item.task_loc_id) ? _c('span', [_vm._v(" - " + _vm._s(props.item.task_loc))]) : _vm._e()]), _vm._v(" "), _c('span', {
              staticClass: "caption grey--text"
            }, [_vm._v(_vm._s('#' + props.item.task_id))])])]), _vm._v(" "), _c('v-flex', {
              staticClass: "pa-0",
              attrs: {
                "xs2": "",
                "sm1": ""
              }
            }, [_c('v-menu', {
              staticClass: "mt-0",
              attrs: {
                "close-on-content-click": false,
                "top": "",
                "right": ""
              }
            }, [_c('span', {
              attrs: {
                "slot": "activator"
              },
              slot: "activator"
            }, [_c('v-btn', {
              attrs: {
                "slot": "activator",
                "icon": ""
              },
              slot: "activator"
            }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', {
              staticClass: "py-0"
            }, [_c('v-list-group', {
              attrs: {
                "no-action": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function() {
                  return [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change Status")])], 1)]
                },
                proxy: true
              }], null, true),
              model: {
                value: (_vm.lTask.task_status),
                callback: function($$v) {
                  _vm.$set(_vm.lTask, "task_status", $$v)
                },
                expression: "lTask.task_status"
              }
            }, [_vm._v(" "), _vm._l((_vm.taskStatus), function(status, i) {
              return (props.item.task_status !== status) ? _c('v-list-tile', {
                key: i,
                on: {
                  "click": function($event) {
                    return _vm.prepareTaskStatus(props.item, status)
                  }
                }
              }, [_c('v-list-tile-title', [_vm._v("\n                                        " + _vm._s(status) + "\n                                      ")])], 1) : _vm._e()
            })], 2), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(props.item, 'Assigned')
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Assign to")])], 1) : _vm._e(), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(props.item, 'Pending approval')
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Request for approval")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(props.item, 'Commented')
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("comment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Comment")])], 1) : _vm._e(), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareUpdate(props.item)
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareChecklist(props.item)
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check_box")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Checklist")])], 1), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.loadTimeLine(props.item.task_id)
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Timeline")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
              attrs: {
                "xs12": ""
              }
            }, [_c('v-layout', {
              attrs: {
                "row": "",
                "wrap": ""
              }
            }, [_c('v-flex', {
              attrs: {
                "xs12": ""
              }
            }, [_c('div', {
              staticClass: "pb-2"
            }, [_vm._v(_vm._s(props.item.task_desc))]), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
              attrs: {
                "xs12": ""
              }
            }, [_c('v-layout', {
              attrs: {
                "row": "",
                "wrap": ""
              }
            }, [_c('v-flex', {
              attrs: {
                "xs6": ""
              }
            }, [_c('v-layout', {
              attrs: {
                "row": "",
                "wrap": ""
              }
            }, [_c('v-flex', {
              attrs: {
                "xs3": "",
                "sm2": ""
              }
            }, [_c('v-avatar', {
              staticClass: "pt-0",
              attrs: {
                "slot": "activator",
                "size": "24px"
              },
              slot: "activator"
            }, [_c('img', {
              attrs: {
                "src": _vm.config.STATIC_FILES_DIR + props.item.created_avatar_url
              }
            })])], 1), _vm._v(" "), _c('v-flex', {
              staticClass: "caption",
              attrs: {
                "xs9": "",
                "sm10": ""
              }
            }, [_c('div', {
              staticClass: "primary--text"
            }, [_vm._v("Created by")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.item.created_by))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.task_timestamp) + ' ' + _vm.handy.getTime12Hrs(props.item.task_timestamp)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
              attrs: {
                "xs6": ""
              }
            }, [_c('v-layout', {
              attrs: {
                "row": "",
                "wrap": ""
              }
            }, [_c('v-flex', {
              attrs: {
                "xs3": "",
                "sm2": ""
              }
            }, [_c('v-avatar', {
              staticClass: "pt-0",
              attrs: {
                "slot": "activator",
                "size": "24px"
              },
              slot: "activator"
            }, [(props.item.assigned_to) ? _c('img', {
              attrs: {
                "src": _vm.config.STATIC_FILES_DIR + props.item.assigned_to_avatar_url
              }
            }) : _c('v-icon', {
              staticClass: "grey"
            }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('v-flex', {
              staticClass: "caption",
              attrs: {
                "xs9": "",
                "sm10": ""
              }
            }, [_c('div', {
              staticClass: "primary--text"
            }, [_vm._v("Assigned to")]), _vm._v(" "), (props.item.assigned_to) ? _c('div', [_c('div', [_vm._v(_vm._s(props.item.assigned_to))]), _vm._v(" "), (props.item.assigned_dt) ? _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.assigned_dt) + ' ' + _vm.handy.getTime12Hrs(props.item.assigned_dt)))]) : _vm._e()]) : _c('div', [_vm._v("NA")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
              attrs: {
                "xs12": ""
              }
            }, [_c('v-divider'), _vm._v(" "), _c('v-layout', {
              class: !props.item.tot_files ? 'py-2' : 'pt-2',
              attrs: {
                "row": "",
                "wrap": ""
              }
            }, [_c('v-flex', {
              staticClass: "subheading py-0",
              attrs: {
                "xs4": "",
                "sm6": ""
              }
            }, [_c('div', {
              class: props.item.task_status === 'New' ? 'grey--text' : (props.item.task_status === 'In Progress' ? 'accent--text' : (props.item.task_status === 'Completed' ? 'success--text' : 'error--text'))
            }, [_vm._v("\n                                        " + _vm._s(props.item.task_status) + "\n                                      ")]), _vm._v(" "), (props.item.assigned_user_id === _vm.config.USER_ID && props.item.task_status !== 'Approved' && props.item.task_status === 'Pending approval' && !props.item.is_assigned_to_sv_user) ? _c('div', {
              staticClass: "px-0 py-0"
            }, [_c('v-btn', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(props.item, 'Approved')
                }
              }
            }, [_vm._v("Approve")])], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
              class: props.item.task_status === 'Completed' ? 'pt-0' : 'py-0',
              attrs: {
                "xs5": "",
                "sm4": ""
              }
            }, [_c('div', {
              class: _vm.tab === 'tab-0' ? (_vm.handy.formatDBDate(props.item.plan_end) === _vm.today ? 'orange--text' : (_vm.handy.formatDBDate(props.item.plan_end) < _vm.today ? 'error--text' : '')) : ''
            }, [_vm._v(_vm._s('Due: ' + (props.item.plan_end ? _vm.handy.formatDate(props.item.plan_end) : 'NA')))]), _vm._v(" "), (props.item.task_status === 'Completed') ? _c('div', [_vm._v(_vm._s('End: ' + _vm.handy.formatDate(props.item.act_end) + ' ' + _vm.handy.getTime12Hrs(props.item.act_end)))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
              staticClass: "px-0 pb-0",
              attrs: {
                "xs1": ""
              },
              on: {
                "click": function($event) {
                  return _vm.prepareChecklist(props.item)
                }
              }
            }, [(props.item.tot_cl) ? _c('v-badge', {
              attrs: {
                "overlap": "",
                "color": "info"
              },
              scopedSlots: _vm._u([{
                key: "badge",
                fn: function() {
                  return [_c('span', {
                    staticClass: "caption"
                  }, [_vm._v(_vm._s(props.item.tot_completed_cl + '/' + props.item.tot_cl))])]
                },
                proxy: true
              }], null, true)
            }, [_vm._v(" "), _c('v-icon', {
              staticClass: "pa-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v("check_box")])], 1) : _vm._e()], 1), _vm._v(" "), (props.item.tot_files) ? _c('v-flex', {
              staticClass: "px-2 pb-0 ",
              attrs: {
                "xs1": ""
              },
              on: {
                "click": function($event) {
                  return _vm.loadTimeLine(props.item.task_id)
                }
              }
            }, [_c('v-badge', {
              attrs: {
                "overlap": "",
                "color": "info"
              },
              scopedSlots: _vm._u([{
                key: "badge",
                fn: function() {
                  return [_c('span', {
                    staticClass: "caption"
                  }, [_vm._v(_vm._s(props.item.tot_files))])]
                },
                proxy: true
              }], null, true)
            }, [_vm._v(" "), _c('v-icon', {
              staticClass: "pa-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v("attach_file")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)], 1)], 1)
    }), 1) : _vm._e(), _vm._v(" "), (tabItem === 'all closed') ? _c('infinite-loading', {
      attrs: {
        "spinner": "spiral"
      },
      on: {
        "infinite": _vm.loadMoreClosed
      }
    }, [_c('span', {
      attrs: {
        "slot": "spinner"
      },
      slot: "spinner"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-more"
      },
      slot: "no-more"
    })]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.choosenView === 'list' && _vm.totalTaskList[tabItem] > 0) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pt-0"
    }, [_c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.listViewHeadersm : _vm.listViewHeader,
        "items": _vm.tab === 'tab-0' ? _vm.openTaskList['Past due'].concat(_vm.openTaskList['Due sooner']).concat(_vm.openTaskList['Due later']) : _vm.closedTaskList['All closed'],
        "rows-per-page-items": [10, 25, 50, {
          'text': '$vuetify.dataIterator.rowsPerPageAll',
          'value': -1
        }],
        "pagination": _vm.rowsPerPage,
        "disable-initial-sort": ""
      },
      on: {
        "update:pagination": function($event) {
          _vm.rowsPerPage = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.task_id))]) : _vm._e(), _vm._v(" "), (props.item.task_cat !== 'Project' && _vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.task_cat + ' - ' + props.item.service))]) : _vm._e(), _vm._v(" "), (props.item.task_cat === 'Project' && _vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.task_cat + ' - ' + props.item.proj_name))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.task_desc))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s((props.item.created_by ? props.item.created_by + ' ' : '') + (props.item.task_timestamp ? _vm.handy.formatDate(props.item.task_timestamp) + ' ' + _vm.handy.getTime12Hrs(props.item.task_timestamp) : '')))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s((props.item.assigned_to ? props.item.assigned_to + ' - ' : '') + (props.item.assigned_dt ? _vm.handy.formatDate(props.item.assigned_dt) + ' ' + _vm.handy.getTime12Hrs(props.item.assigned_dt) : '')))]) : _vm._e(), _vm._v(" "), _c('td', {
            class: 'pa-2 ' + (_vm.tab === 'tab-0' ? (_vm.handy.formatDBDate(props.item.plan_end) === _vm.today ? 'warning lighten-2' : (_vm.handy.formatDBDate(props.item.plan_end) < _vm.today ? 'error lighten-2' : '')) : '')
          }, [_vm._v(_vm._s(props.item.plan_end ? _vm.handy.formatDate(props.item.plan_end) : 'NA'))]), _vm._v(" "), _c('td', {
            class: 'pa-2 ' + (props.item.task_status === 'New' ? 'grey--text' : (props.item.task_status === 'In Progress' ? 'accent--text' : (props.item.task_status === 'Completed' ? 'success--text' : 'error--text')))
          }, [_vm._v(_vm._s(props.item.task_status))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_c('v-menu', {
            staticClass: "mt-0",
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "right": ""
            }
          }, [_c('span', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', {
            staticClass: "py-0"
          }, [_c('v-list-group', {
            attrs: {
              "no-action": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function() {
                return [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change Status")])], 1)]
              },
              proxy: true
            }], null, true),
            model: {
              value: (_vm.lTask.task_status),
              callback: function($$v) {
                _vm.$set(_vm.lTask, "task_status", $$v)
              },
              expression: "lTask.task_status"
            }
          }, [_vm._v(" "), _vm._l((_vm.taskStatus), function(status, i) {
            return (props.item.task_status !== status) ? _c('v-list-tile', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(props.item, status)
                }
              }
            }, [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(status) + "\n                ")])], 1) : _vm._e()
          })], 2), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareTaskStatus(props.item, 'Assigned')
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Assign to")])], 1) : _vm._e(), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareTaskStatus(props.item, 'Pending approval')
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Request for approval")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareTaskStatus(props.item, 'Commented')
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("comment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Comment")])], 1) : _vm._e(), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareChecklist(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check_box")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Checklist")])], 1), _vm._v(" "), (props.item.task_status !== 'Completed') ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.task_id)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Timeline")])], 1)], 1)], 1)], 1)])]
        }
      }], null, true)
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.choosenView === 'calendar' && _vm.totalTaskList[tabItem] > 0) ? _c('v-flex', {
      class: _vm.tab === 'tab-0' ? 'pb-0 pt-2' : 'pt-4 pb-0',
      attrs: {
        "xs12": ""
      }
    }, [_c('v-flex', {
      staticClass: "pt-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "fab": "",
        "outline": "",
        "small": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.prevMonth(n)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("keyboard_arrow_left")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs8": ""
      }
    }, [_c('span', {
      staticClass: "info--text title"
    }, [_vm._v(_vm._s(_vm.calViewTitle))]), _vm._v(" "), (_vm.tab === 'tab-0') ? _c('div', {
      staticClass: "info--text"
    }, [_vm._v(_vm._s(_vm.totPlanedTask) + " planned in this month.\n          "), (_vm.totUnplanedTask > 0) ? _c('span', {
      staticClass: "warning--text"
    }, [_vm._v(" " + _vm._s(_vm.totUnplanedTask) + " unplanned.")]) : _vm._e()]) : _c('div', {
      staticClass: "info--text"
    }, [_vm._v("\n          " + _vm._s(_vm.totClosedTask) + " closed in this month.\n        ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right",
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "fab": "",
        "outline": "",
        "small": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.nextMonth(n)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-sheet', {
      attrs: {
        "height": "500"
      }
    }, [_c('v-calendar', {
      ref: "calendar",
      refInFor: true,
      attrs: {
        "now": _vm.today,
        "value": _vm.today,
        "weekdays": [1, 2, 3, 4, 5, 6, 0],
        "color": "primary"
      },
      scopedSlots: _vm._u([{
        key: "day",
        fn: function(ref) {
          var date = ref.date;

          return [_vm._l((_vm.eventsMap[date]), function(event) {
            return [_c('v-menu', {
              key: event.task_id,
              attrs: {
                "close-on-content-click": false,
                "offset-x": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;

                  return [_c('div', _vm._g({
                    directives: [{
                      name: "ripple",
                      rawName: "v-ripple"
                    }],
                    class: _vm.tab === 'tab-0' ? (event.plan_end === _vm.today ? 'warning lighten-2 px-1 my-2' : (event.plan_end < _vm.today ? 'error lighten-2 px-1' : (event.plan_end > _vm.today ? 'success px-1 lighten-2' : ''))) : 'success lighten-2',
                    staticStyle: {
                      "margin": "0px 1px 2px 1px",
                      "border-radius": "4px"
                    },
                    domProps: {
                      "innerHTML": _vm._s(_vm.$vuetify.breakpoint.smAndUp ? event.task_desc.substring(0, 40) : event.task_desc.substring(0, 5))
                    }
                  }, on))]
                }
              }], null, true)
            }, [_vm._v(" "), _c('v-card', {
              attrs: {
                "width": _vm.$vuetify.breakpoint.smAndUp ? '500px' : ''
              }
            }, [_c('v-card-title', {
              staticClass: "py-0 primary white--text"
            }, [_c('v-flex', {
              staticClass: "pa-0",
              attrs: {
                "xs10": "",
                "sm11": ""
              }
            }, [_c('div', {
              staticClass: "pt-1 lighten-1 accent--text caption font-weight-bold"
            }, [_vm._v("\n                " + _vm._s(event.comm_name) + "\n              ")]), _vm._v(" "), (event.task_cat !== 'Project') ? _c('div', {
              staticClass: "py-1 title"
            }, [_vm._v("\n                " + _vm._s(event.task_cat + ' - ' + event.service) + " "), _c('span', {
              staticClass: "caption"
            }, [_vm._v(_vm._s('(Task #' + event.task_id + ')'))])]) : _c('div', {
              staticClass: "pt-1 subheading"
            }, [_vm._v("\n                " + _vm._s(event.task_cat + ' - ' + event.proj_name) + " "), _c('span', {
              staticClass: "caption"
            }, [_vm._v(_vm._s('(Task #' + event.task_id + ')'))])])]), _vm._v(" "), _c('v-flex', {
              staticClass: "pa-0",
              attrs: {
                "xs2": "",
                "sm1": ""
              }
            }, [_c('v-menu', {
              staticClass: "mt-0",
              attrs: {
                "close-on-content-click": false,
                "top": "",
                "right": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;

                  return [_c('v-btn', _vm._g({
                    attrs: {
                      "icon": ""
                    }
                  }, on), [_c('v-icon', {
                    attrs: {
                      "color": "white"
                    }
                  }, [_vm._v("more_vert")])], 1)]
                }
              }], null, true)
            }, [_vm._v(" "), _c('v-list', {
              staticClass: "py-0"
            }, [_c('v-list-group', {
              attrs: {
                "no-action": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function() {
                  return [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change Status")])], 1)]
                },
                proxy: true
              }], null, true),
              model: {
                value: (_vm.lTask.task_status),
                callback: function($$v) {
                  _vm.$set(_vm.lTask, "task_status", $$v)
                },
                expression: "lTask.task_status"
              }
            }, [_vm._v(" "), _vm._l((_vm.taskStatus), function(status, i) {
              return (event.task_status !== status) ? _c('v-list-tile', {
                key: i,
                on: {
                  "click": function($event) {
                    return _vm.prepareTaskStatus(event, status)
                  }
                }
              }, [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(status) + "\n                ")])], 1) : _vm._e()
            })], 2), _vm._v(" "), (event.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(event, 'Assigned')
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Assign to")])], 1) : _vm._e(), _vm._v(" "), (event.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(event, 'Pending approval')
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Request for approval")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (event.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(event, 'Commented')
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("comment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Comment")])], 1) : _vm._e(), _vm._v(" "), (event.task_status !== 'Completed') ? _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareUpdate(event)
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.prepareChecklist(event)
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check_box")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Checklist")])], 1), _vm._v(" "), (event.task_status !== 'Completed') ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-tile', {
              on: {
                "click": function($event) {
                  return _vm.loadTimeLine(event.task_id)
                }
              }
            }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Timeline")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "py-0 black--text"
            }, [_c('v-flex', {
              attrs: {
                "xs12": ""
              }
            }, [_c('v-flex', {
              staticClass: "pt-0",
              attrs: {
                "xs12": ""
              }
            }, [_c('div', {
              staticClass: "pa-2"
            }, [_vm._v(_vm._s(event.task_desc))]), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
              staticClass: "py-2",
              attrs: {
                "xs12": ""
              }
            }, [_c('v-layout', [_c('v-flex', {
              attrs: {
                "xs6": ""
              }
            }, [_c('v-layout', [_c('v-flex', {
              attrs: {
                "xs3": "",
                "sm2": ""
              }
            }, [_c('v-avatar', {
              staticClass: "pt-0",
              attrs: {
                "slot": "activator",
                "size": "24px"
              },
              slot: "activator"
            }, [_c('img', {
              attrs: {
                "src": _vm.config.STATIC_FILES_DIR + event.created_avatar_url
              }
            })])], 1), _vm._v(" "), _c('v-flex', {
              staticClass: "caption",
              attrs: {
                "xs9": "",
                "sm10": ""
              }
            }, [_c('div', {
              staticClass: "primary--text"
            }, [_vm._v("Created by")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(event.created_by))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(event.task_timestamp) + ' ' + _vm.handy.getTime12Hrs(event.task_timestamp)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
              attrs: {
                "xs6": ""
              }
            }, [_c('v-layout', [_c('v-flex', {
              attrs: {
                "xs3": "",
                "sm2": ""
              }
            }, [_c('v-avatar', {
              staticClass: "pt-0",
              attrs: {
                "slot": "activator",
                "size": "24px"
              },
              slot: "activator"
            }, [(event.assigned_to) ? _c('img', {
              attrs: {
                "src": _vm.config.STATIC_FILES_DIR + event.assigned_to_avatar_url
              }
            }) : _c('v-icon', {
              staticClass: "grey"
            }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('v-flex', {
              staticClass: "caption",
              attrs: {
                "xs9": "",
                "sm10": ""
              }
            }, [_c('div', {
              staticClass: "primary--text"
            }, [_vm._v("Assigned to")]), _vm._v(" "), (event.assigned_to) ? _c('div', [_c('div', [_vm._v(_vm._s(event.assigned_to))]), _vm._v(" "), (event.assigned_dt) ? _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(event.assigned_dt) + ' ' + _vm.handy.getTime12Hrs(event.assigned_dt)))]) : _vm._e()]) : _c('div', [_vm._v("NA")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
              staticClass: "pt-1",
              attrs: {
                "xs12": ""
              }
            }, [_c('v-layout', {
              class: !event.tot_files ? 'py-2' : 'pt-2'
            }, [_c('v-flex', {
              staticClass: "subheading py-0",
              attrs: {
                "xs4": "",
                "sm5": ""
              }
            }, [_c('div', {
              class: event.task_status === 'New' ? 'grey--text' : (event.task_status === 'In Progress' ? 'accent--text' : (event.task_status === 'Completed' ? 'success--text' : 'error--text'))
            }, [_vm._v("\n                " + _vm._s(event.task_status) + "\n              ")]), _vm._v(" "), (event.assigned_user_id === _vm.config.SV_USER_ID && event.is_assigned_to_sv_user && event.task_status !== 'Approved' && event.task_status === 'Pending approval') ? _c('div', {
              staticClass: "px-0 py-0"
            }, [_c('v-btn', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.prepareTaskStatus(event, 'Approved')
                }
              }
            }, [_vm._v("Approve")])], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
              class: event.task_status === 'Completed' ? 'pt-0' : 'py-0',
              attrs: {
                "xs4": "",
                "sm5": ""
              }
            }, [_c('div', {
              class: _vm.tab === 'tab-0' ? (_vm.handy.formatDBDate(event.plan_end) === _vm.today ? 'orange--text' : (_vm.handy.formatDBDate(event.plan_end) < _vm.today ? 'error--text' : '')) : ''
            }, [_vm._v(_vm._s('Due: ' + (event.plan_end ? _vm.handy.formatDate(event.plan_end) : 'NA')))]), _vm._v(" "), (event.task_status === 'Completed') ? _c('div', [_vm._v(_vm._s('End: ' + _vm.handy.formatDate(event.act_end) + ' ' + _vm.handy.getTime12Hrs(event.act_end)))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
              staticClass: "px-0 pb-0 text-xs-left",
              attrs: {
                "xs1": ""
              }
            }, [(event.tot_cl) ? _c('v-badge', {
              attrs: {
                "overlap": "",
                "color": "info"
              },
              scopedSlots: _vm._u([{
                key: "badge",
                fn: function() {
                  return [_c('span', {
                    staticClass: "caption"
                  }, [_vm._v(_vm._s(event.tot_completed_cl + '/' + event.tot_cl))])]
                },
                proxy: true
              }], null, true)
            }, [_vm._v(" "), _c('v-icon', {
              staticClass: "pa-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v("check_box")])], 1) : _vm._e()], 1), _vm._v(" "), (event.tot_files) ? _c('v-flex', {
              staticClass: "px-0 pb-0 text-xs-right",
              attrs: {
                "xs1": ""
              }
            }, [_c('v-badge', {
              attrs: {
                "overlap": "",
                "color": "info"
              },
              scopedSlots: _vm._u([{
                key: "badge",
                fn: function() {
                  return [_c('span', {
                    staticClass: "caption"
                  }, [_vm._v(_vm._s(event.tot_files))])]
                },
                proxy: true
              }], null, true)
            }, [_vm._v(" "), _c('v-icon', {
              staticClass: "pa-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v("attach_file")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)]
          })]
        }
      }], null, true),
      model: {
        value: (_vm.start),
        callback: function($$v) {
          _vm.start = $$v
        },
        expression: "start"
      }
    })], 1)], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('v-speed-dial', {
    staticStyle: {
      "position": "fixed",
      "top": "90px",
      "right": "10px"
    },
    attrs: {
      "direction": _vm.$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'
    },
    model: {
      value: (_vm.calFab),
      callback: function($$v) {
        _vm.calFab = $$v
      },
      expression: "calFab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "fab": "",
      "color": "accent"
    },
    slot: "activator",
    model: {
      value: (_vm.calFab),
      callback: function($$v) {
        _vm.calFab = $$v
      },
      expression: "calFab"
    }
  }, [_c('v-icon', [_vm._v("remove_red_eye")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "fab": "",
            "small": "",
            "color": _vm.choosenView === 'card' ? 'info' : ''
          },
          nativeOn: {
            "click": function($event) {
              return _vm.changeView('card')
            }
          }
        }, on), [_c('v-icon', [_vm._v("filter_frames")])], 1)]
      }
    }], null, false, 2865765141)
  }, [_vm._v(" "), _c('span', [_vm._v("Card view")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ma-1",
          attrs: {
            "fab": "",
            "small": "",
            "color": _vm.choosenView === 'list' ? 'info' : ''
          },
          nativeOn: {
            "click": function($event) {
              return _vm.changeView('list')
            }
          }
        }, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }], null, false, 1363469397)
  }, [_vm._v(" "), _c('span', [_vm._v("List view")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "fab": "",
            "small": "",
            "color": _vm.choosenView === 'calendar' ? 'info' : ''
          },
          nativeOn: {
            "click": function($event) {
              return _vm.changeView('calendar')
            }
          }
        }, on), [_c('v-icon', [_vm._v("date_range")])], 1)]
      }
    }], null, false, 147981747)
  }, [_vm._v(" "), _c('span', [_vm._v("Calendar view")])])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.lAction === 'view-task') ? _c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:15px;' : 'bottom:15px; left:315px;')),
          attrs: {
            "small": "",
            "dark": "",
            "fab": "",
            "fixed": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareBucket($event)
            }
          }
        }, on), [_c('v-icon', [_vm._v("storage")])], 1) : _vm._e()]
      }
    }], null, false, 704475637)
  }, [_vm._v(" "), _c('span', [_vm._v("Upload tasks from bucket")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.lAction === 'view-task') ? _c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:65px;' : 'bottom:15px; left:365px;')),
          attrs: {
            "small": "",
            "dark": "",
            "fab": "",
            "fixed": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareUpload($event)
            }
          }
        }, on), [_c('v-icon', [_vm._v("file_upload")])], 1) : _vm._e()]
      }
    }], null, false, 4024384763)
  }, [_vm._v(" "), _c('span', [_vm._v("Upload task from csv")])]), _vm._v(" "), (_vm.lAction === 'view-task') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:115px;' : 'bottom:15px; left:415px;')),
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareFilter()
      }
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": "",
      "color": "info"
    },
    scopedSlots: _vm._u([(_vm.enabledFilter[this.tab]) ? {
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("done")])]
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pa-2"
  }, [_vm._v("filter_list")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.lAction === 'view-task') ? _c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
          attrs: {
            "dark": "",
            "fab": "",
            "fixed": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareCreate()
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("add")])], 1) : _vm._e()]
      }
    }], null, false, 3264308358)
  }, [_vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Create task")])])], 2) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'create-task' || _vm.lAction === 'update-task') ? _c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-2 pb-2 pt-0"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.catList,
      "label": "Task Category",
      "item-text": "task_cat",
      "item-value": "task_cat_id",
      "return-object": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.findCat(_vm.lTask)
      }
    },
    model: {
      value: (_vm.lTask.task_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "task_cat_pair", $$v)
      },
      expression: "lTask.task_cat_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.prepareCategory
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), (_vm.lTask.task_cat === 'Project') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Project name",
      "rules": [_vm.rules.required],
      "maxlength": "25",
      "hide-details": ""
    },
    model: {
      value: (_vm.lTask.proj_name),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "proj_name", $$v)
      },
      expression: "lTask.proj_name"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.cats,
      "label": "Service",
      "item-text": "comp_cat",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.lTask.task_service),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "task_service", $$v)
      },
      expression: "lTask.task_service"
    }
  })], 1), _vm._v(" "), (_vm.lTask.task_cat !== 'Project') ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": "",
      "to": {
        path: '/compset'
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.locList,
      "label": "Location (optional)",
      "item-text": "task_loc",
      "item-value": "task_loc_id",
      "hide-details": "",
      "return-object": "",
      "clearable": ""
    },
    model: {
      value: (_vm.lTask.task_loc_pair),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "task_loc_pair", $$v)
      },
      expression: "lTask.task_loc_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.prepareLoc
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Task description",
      "rows": "2",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "250"
    },
    model: {
      value: (_vm.lTask.task_desc),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "task_desc", $$v)
      },
      expression: "lTask.task_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "planStartDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lTask.plan_start
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTask, "plan_start", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTask, "plan_start", $event)
      }
    },
    model: {
      value: (_vm.planStartDt),
      callback: function($$v) {
        _vm.planStartDt = $$v
      },
      expression: "planStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Plan start date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lTask.plan_start),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "plan_start", $$v)
      },
      expression: "lTask.plan_start"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lTask.plan_start),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "plan_start", $$v)
      },
      expression: "lTask.plan_start"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.planStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.planStartDt.save(_vm.lTask.plan_start)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "planEndDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lTask.plan_end
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTask, "plan_end", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTask, "plan_end", $event)
      }
    },
    model: {
      value: (_vm.planEndDt),
      callback: function($$v) {
        _vm.planEndDt = $$v
      },
      expression: "planEndDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Plan end date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lTask.plan_end),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "plan_end", $$v)
      },
      expression: "lTask.plan_end"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.lTask.plan_start,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lTask.plan_end),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "plan_end", $$v)
      },
      expression: "lTask.plan_end"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.planEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.planEndDt.save(_vm.lTask.plan_end)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.mcList,
      "label": "Assigned to",
      "item-text": "user_name",
      "return-object": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lTask.assigned_user_pair),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "assigned_user_pair", $$v)
      },
      expression: "lTask.assigned_user_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['High', 'Normal', 'Low'],
      "label": "Priority",
      "hide-details": ""
    },
    model: {
      value: (_vm.lTask.priority),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "priority", $$v)
      },
      expression: "lTask.priority"
    }
  })], 1), _vm._v(" "), (_vm.lAction === 'update-task') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgStartDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lTask.act_start
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTask, "act_start", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTask, "act_start", $event)
      }
    },
    model: {
      value: (_vm.dlgStartDate),
      callback: function($$v) {
        _vm.dlgStartDate = $$v
      },
      expression: "dlgStartDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Actual start date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lTask.act_start),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "act_start", $$v)
      },
      expression: "lTask.act_start"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.lTask.plan_start,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lTask.act_start),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "act_start", $$v)
      },
      expression: "lTask.act_start"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgStartDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgStartDate.save(_vm.lTask.act_start)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgEndDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lTask.act_end
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTask, "act_end", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTask, "act_end", $event)
      }
    },
    model: {
      value: (_vm.dlgEndDate),
      callback: function($$v) {
        _vm.dlgEndDate = $$v
      },
      expression: "dlgEndDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Actual end date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lTask.act_end),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "act_end", $$v)
      },
      expression: "lTask.act_end"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "max": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lTask.act_end),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "act_end", $$v)
      },
      expression: "lTask.act_end"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgEndDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgEndDate.save(_vm.lTask.act_end)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.taskStatus,
      "label": "Task Status",
      "hide-details": ""
    },
    model: {
      value: (_vm.lTask.task_status),
      callback: function($$v) {
        _vm.$set(_vm.lTask, "task_status", $$v)
      },
      expression: "lTask.task_status"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lTask)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lTask.files && _vm.lTask.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lTask.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.file_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update-task' && _vm.lTask.created_user_id === _vm.config.USER_ID && !_vm.lTask.is_created_by_sv_user) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteTask(_vm.lTask)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showDlgStatus),
      callback: function($$v) {
        _vm.showDlgStatus = $$v
      },
      expression: "showDlgStatus"
    }
  }, [_c('v-card', [(_vm.lTaskStatus.task_action === 'Assigned' || _vm.lTaskStatus.task_action === 'Need More Info.' || _vm.lTaskStatus.task_action === 'Pending approval') ? _c('v-card-title', {
    staticClass: "py-3 title grey lighten-4"
  }, [(_vm.lTaskStatus.task_action === 'Assigned' || _vm.lTaskStatus.task_action === 'Need More Info.') ? _c('div', [_vm._v("Assign to")]) : _vm._e(), _vm._v(" "), (_vm.lTaskStatus.task_action === 'Pending approval') ? _c('div', [_vm._v("Request for approval")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lTaskStatus.task_action === 'Assigned' || _vm.lTaskStatus.task_action === 'Need More Info.' || _vm.lTaskStatus.task_action === 'Pending approval') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "label": "Assigned to",
      "items": _vm.mcList,
      "item-text": "user_name",
      "return-object": ""
    },
    model: {
      value: (_vm.lTaskStatus.assigned_user_pair),
      callback: function($$v) {
        _vm.$set(_vm.lTaskStatus, "assigned_user_pair", $$v)
      },
      expression: "lTaskStatus.assigned_user_pair"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lTaskStatus.task_action === 'Completed') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-1",
    attrs: {
      "xs8": "",
      "sm5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgEndDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lTaskStatus.act_end
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTaskStatus, "act_end", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTaskStatus, "act_end", $event)
      }
    },
    model: {
      value: (_vm.dlgEndDate),
      callback: function($$v) {
        _vm.dlgEndDate = $$v
      },
      expression: "dlgEndDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Actual end date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lTaskStatus.act_end),
      callback: function($$v) {
        _vm.$set(_vm.lTaskStatus, "act_end", $$v)
      },
      expression: "lTaskStatus.act_end"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "max": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lTaskStatus.act_end),
      callback: function($$v) {
        _vm.$set(_vm.lTaskStatus, "act_end", $$v)
      },
      expression: "lTaskStatus.act_end"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgEndDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgEndDate.save(_vm.lTaskStatus.act_end)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgEndTime",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lTaskStatus.endTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTaskStatus, "endTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTaskStatus, "endTime", $event)
      }
    },
    model: {
      value: (_vm.dlgEndTime),
      callback: function($$v) {
        _vm.dlgEndTime = $$v
      },
      expression: "dlgEndTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lTaskStatus.endTime),
      callback: function($$v) {
        _vm.$set(_vm.lTaskStatus, "endTime", $$v)
      },
      expression: "lTaskStatus.endTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lTaskStatus.endTime),
      callback: function($$v) {
        _vm.$set(_vm.lTaskStatus, "endTime", $$v)
      },
      expression: "lTaskStatus.endTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgEndTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgEndTime.save(_vm.lTaskStatus.endTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outline": "",
      "placeholder": _vm.placeHolder,
      "maxlength": "250"
    },
    model: {
      value: (_vm.lTaskStatus.notes),
      callback: function($$v) {
        _vm.$set(_vm.lTaskStatus, "notes", $$v)
      },
      expression: "lTaskStatus.notes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "statusFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lTaskStatus)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lTaskStatus.files && _vm.lTaskStatus.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lTaskStatus.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.file_name))])], 1)
  }), 0) : _c('span', [_vm._v("Attachment if any"), _c('br'), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(supports images, pdfs, docs and excels upto 20MB)")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "px-0 pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDlgStatus = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.postTaskStatus()
      }
    }
  }, [_vm._v("submit")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showTimeline),
      callback: function($$v) {
        _vm.showTimeline = $$v
      },
      expression: "showTimeline"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_c('div', [_vm._v("Timeline")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTimeline = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-timeline', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.lTimeLine), function(timeline, n) {
    return _c('v-timeline-item', {
      key: n,
      class: n === _vm.lTimeLine.length - 1 ? 'pb-0' : '',
      attrs: {
        "small": "",
        "id": 'timeline_' + n
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c('v-avatar', [_c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + timeline.avatar_url
            }
          })])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-card', [(timeline.task_action === 'Assigned' || timeline.task_action === 'Need More Info.') ? _c('div', [_c('v-card-title', {
      staticClass: "title pa-2"
    }, [_vm._v("\n              " + _vm._s(timeline.task_action) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0 pb-2"
    }, [_c('div', [_vm._v(_vm._s('Assigned to: ' + timeline.assigned_to))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(timeline.notes))])])], 1) : _c('div', [_c('v-card-title', {
      class: timeline.task_action === 'Commented' && timeline.created_by_user_id === _vm.config.USER_ID && !_vm.lTask.is_created_by_sv_user && _vm.$vuetify.breakpoint.smAndUp ? 'title px-2 py-0' : 'title pa-2'
    }, [_c('div', [_vm._v(_vm._s(timeline.task_action))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (timeline.task_action === 'Commented' && timeline.created_by_user_id === _vm.config.USER_ID && !_vm.lTask.is_created_by_sv_user && !timeline.is_created_by_sv_user) ? _c('span', {
      staticClass: "text-xs-right"
    }, [_c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteComment(timeline)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.prepareUpdateComment(timeline)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("edit")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
      class: timeline.notes ? 'py-0' : 'pl-2 py-0 pr-0'
    }, [(timeline.task_action === 'Pending approval') ? _c('div', [_vm._v(_vm._s('Request sent to: ' + timeline.assigned_to))]) : _vm._e(), _vm._v(" "), (timeline.task_action === 'Approved') ? _c('div', [_vm._v(_vm._s('Assigned back to: ' + timeline.assigned_to))]) : _vm._e(), _vm._v(" "), (timeline.notes !== '') ? _c('div', [(timeline.task_action === 'Task Updated') ? _c('div', _vm._l((timeline.timeLineNote), function(note, i) {
      return _c('div', {
        key: i
      }, [(note) ? _c('span', [_vm._v(_vm._s(i + 1 + '. ' + note))]) : _vm._e()])
    }), 0) : _c('div', {
      staticClass: "pb-1"
    }, [_vm._v("\n                  " + _vm._s(timeline.notes) + "\n                ")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.lTimeLine.attachImages && _vm.lTimeLine.attachImages.filter(function (rec) { return rec.task_action === timeline.task_action && timeline.task_det_id === rec.task_det_id && _vm.handy.formatDateTime(rec.attach_timestamp) === _vm.handy.formatDateTime(timeline.action_dt); }).length ||
      _vm.lTimeLine.attachFile && _vm.lTimeLine.attachFile.filter(function (rec) { return rec.task_action === timeline.task_action && timeline.task_det_id === rec.task_det_id && _vm.handy.formatDateTime(rec.attach_timestamp) === _vm.handy.formatDateTime(timeline.action_dt); })) ? _c('v-container', {
      staticClass: "pa-0",
      attrs: {
        "grid-list-sm": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.lTimeLine.attachImages.length && _vm.lTimeLine.attachImages.filter(function (rec) { return rec.task_action === timeline.task_action; }).length > 0) ? _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [((_vm.lTimeLine.attachImages.filter(function (rec) { return rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id; }).length > 0) && (_vm.lTimeLine.attachFile.filter(function (rec) { return rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id; }).length > 0)) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      staticClass: "caption grey--text mb-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm2": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm8": ""
      }
    }, [_vm._v("\n                      Image Attachments\n                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "sm2": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2"
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      directives: [{
        name: "viewer",
        rawName: "v-viewer",
        value: (_vm.options),
        expression: "options"
      }],
      staticClass: "clearfix"
    }, [_vm._l((_vm.lTimeLine.attachImages), function(file, index) {
      return [((file.task_action === timeline.task_action && file.task_det_id === timeline.task_det_id)) ? _c('span', [_c('img', {
        key: index,
        staticClass: "ma-1",
        staticStyle: {
          "display": "inline-block",
          "cursor": "pointer"
        },
        attrs: {
          "width": "80px",
          "src": file.file_url,
          "data-source": file.file_url
        }
      })]) : _vm._e()]
    })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.lTimeLine.attachFile.length && _vm.lTimeLine.attachFile.filter(function (rec) { return rec.task_action === timeline.task_action; }).length > 0) ? _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [((_vm.lTimeLine.attachImages.filter(function (rec) { return rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id; }).length > 0) && (_vm.lTimeLine.attachFile.filter(function (rec) { return rec.task_action === timeline.task_action && rec.task_det_id === timeline.task_det_id; }).length > 0)) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      staticClass: "caption grey--text mb-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm2": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm8": ""
      }
    }, [_vm._v("\n                      Other Attachments\n                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "sm2": ""
      }
    }, [_c('v-divider', {
      staticClass: "mt-2"
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, _vm._l((_vm.lTimeLine.attachFile), function(file, index) {
      return _c('span', {
        key: index,
        staticClass: "ma-1"
      }, [((file.task_action === timeline.task_action && file.task_det_id === timeline.task_det_id)) ? _c('v-chip', [_vm._v("\n                      " + _vm._s(file.file_name) + "\n                      "), _c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": file.file_url,
          "download": ""
        }
      }, [_c('v-btn', {
        staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
        attrs: {
          "small": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e()], 1)
    }), 0)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
      staticClass: "caption pa-2"
    }, [_vm._v("\n          " + _vm._s(timeline.created_by) + "\n          "), _c('span', {
      staticClass: "grey--text pl-2"
    }, [_vm._v(_vm._s(_vm.handy.formatDate(timeline.action_dt) + ' ' + _vm.handy.getTime12Hrs(timeline.action_dt)))])])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    staticClass: "caption",
    attrs: {
      "inset": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showFilter),
      callback: function($$v) {
        _vm.showFilter = $$v
      },
      expression: "showFilter"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text"
  }, [_vm._v("Filter by attributes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.catList,
      "label": "Category",
      "item-text": "task_cat",
      "item-value": "task_cat_id",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.filterTaskCatList(_vm.filterListByTab[_vm.tab])
      }
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].task_cat_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "task_cat_list", $$v)
      },
      expression: "filterListByTab[tab].task_cat_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.cats,
      "label": "Service",
      "item-text": "comp_cat",
      "item-value": "comp_cat_id",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].task_service_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "task_service_list", $$v)
      },
      expression: "filterListByTab[tab].task_service_list"
    }
  })], 1), _vm._v(" "), (_vm.filterListByTab[_vm.tab].is_proj_cat) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.projName.filter(function (rec) { return rec !== ''; }),
      "label": "Project",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].proj_name_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "proj_name_list", $$v)
      },
      expression: "filterListByTab[tab].proj_name_list"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.locList,
      "label": "Location",
      "item-text": "task_loc",
      "item-value": "task_loc_id",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].task_loc_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "task_loc_list", $$v)
      },
      expression: "filterListByTab[tab].task_loc_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Severity",
      "items": ['High', 'Normal', 'Low'],
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].priority_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "priority_list", $$v)
      },
      expression: "filterListByTab[tab].priority_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": _vm.filterStatus,
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].task_status_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "task_status_list", $$v)
      },
      expression: "filterListByTab[tab].task_status_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by people")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Created by",
      "items": _vm.mcList,
      "item-text": "user_name",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].created_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "created_user_pair_list", $$v)
      },
      expression: "filterListByTab[tab].created_user_pair_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.mcList,
      "label": "Assigned to",
      "item-text": "user_name",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].assigned_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "assigned_user_pair_list", $$v)
      },
      expression: "filterListByTab[tab].assigned_user_pair_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by date")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterListByTab[_vm.tab].from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDate),
      callback: function($$v) {
        _vm.dlgFromDate = $$v
      },
      expression: "dlgFromDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Due from",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterListByTab[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $$v)
      },
      expression: "filterListByTab[tab].from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $$v)
      },
      expression: "filterListByTab[tab].from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDate.save(_vm.filterListByTab[_vm.tab].from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterListByTab[_vm.tab].to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDate),
      callback: function($$v) {
        _vm.dlgToDate = $$v
      },
      expression: "dlgToDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Due till",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterListByTab[_vm.tab].to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "to_dt", $$v)
      },
      expression: "filterListByTab[tab].to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "to_dt", $$v)
      },
      expression: "filterListByTab[tab].to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDate.save(_vm.filterListByTab[_vm.tab].to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showFilter = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'upload-task' || _vm.lAction === 'upload-bucket') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          Upload " + _vm._s(_vm.lAction === 'upload-bucket' ? 'Task Bucket' : 'Tasks') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lAction === 'upload-bucket' ? 'In just 5 steps' : 'In just 4 steps') + "\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template")]), _vm._v(" "), (_vm.lAction === 'upload-task') ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "../static/files/Smartility_Task_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)]) : _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "../static/files/Smartility_Task_Bucket_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")]), _vm._v(" "), (_vm.lAction === 'upload-task') ? _c('div', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("(Tip: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.LoadAssignedUserDetails
    }
  }, [_vm._v("Click here")]), _vm._v(" to see the list of users that you can assign a task to)")])]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), (_vm.lAction === 'upload-bucket') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Name your bucket")]), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": false,
      "hide-details": ""
    },
    model: {
      value: (_vm.bucketType),
      callback: function($$v) {
        _vm.bucketType = $$v
      },
      expression: "bucketType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Create new bucket",
      "value": "new"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Append into existing bucket",
      "value": "existing"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.bucketType === 'new') ? _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'pt-4 mt-3' : 'mb-2 px-5',
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Enter bucket name",
      "hide-details": "",
      "maxlength": "50",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lBucket.task_bucket_name),
      callback: function($$v) {
        _vm.$set(_vm.lBucket, "task_bucket_name", $$v)
      },
      expression: "lBucket.task_bucket_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bucketType !== 'new') ? _c('v-flex', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'pt-5 mt-4' : 'mb-2 px-5',
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.bucketList,
      "item-value": "task_bucket_id",
      "item-text": "task_bucket_name",
      "placeholder": "Choose existing bucket",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lBucket.task_bucket_id),
      callback: function($$v) {
        _vm.$set(_vm.lBucket, "task_bucket_id", $$v)
      },
      expression: "lBucket.task_bucket_id"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [(_vm.lAction === 'upload-bucket') ? _c('span', [_vm._v("Step 5")]) : _c('span', [_vm._v("Step 4")])]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("Uniservice takes care of rest")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [(_vm.lAction === 'upload-bucket') ? _c('span', [_vm._v("Step 6")]) : _c('span', [_vm._v("Step 5")])]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [(_vm.lAction === 'upload-bucket') ? _c('span', [_vm._v("Step 7")]) : _c('span', [_vm._v("Step 6")])]), _vm._v(" "), (_vm.lAction === 'upload-bucket') ? _c('span', [_vm._v("Create task bucket")]) : _c('span', [_vm._v("Create task records")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0 pr-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          " + _vm._s(_vm.lBucket.task_bucket_name || _vm.lBucket.task_bucket_id ? 'Upload Task Bucket' : 'Upload Tasks') + "\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Tasks uploaded successfully"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Tasks upload failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Tasks upload partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n              ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n              " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n            ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelValidation($event)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadTask($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2 pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-xs-left",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id ? _vm.loadHeadSm : (_vm.$vuetify.breakpoint.smAndUp && _vm.lBucket.task_bucket_name || _vm.lBucket.task_bucket_id ? _vm.loadBucketHead : _vm.loadHead),
      "items": _vm.recsLoaded,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.task_cat))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.service))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.proj_name))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.task_desc))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.check_list))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.plan_start))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.plan_end))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.assigned_to))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.priority))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.task_status))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.act_start))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.lBucket.task_bucket_name && !_vm.lBucket.task_bucket_id) ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.act_end))]) : _vm._e()])]
      }
    }], null, false, 2702718578)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.manageTaskCat),
      callback: function($$v) {
        _vm.manageTaskCat = $$v
      },
      expression: "manageTaskCat"
    }
  }, [_c('v-form', [(_vm.lMAction === 'view') ? _c('v-card', {
    attrs: {
      "flat": "",
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4 py-0"
  }, [_vm._v("\n        Task Category\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.manageTaskCat = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "accent",
      "flat": ""
    },
    on: {
      "click": _vm.createManageTask
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.ManageTaskHead,
      "items": _vm.catList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEdit(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.task_cat))])])]
      }
    }], null, false, 1944245392)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lMAction === 'create' || _vm.lMAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "acForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveTaskCat(_vm.lMAction)
      }
    }
  }, [_c('v-card', {
    staticClass: "pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          " + _vm._s(_vm.handy.startWithUpper(_vm.lMAction)) + " Task Category\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Category name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lCat.task_cat),
      callback: function($$v) {
        _vm.$set(_vm.lCat, "task_cat", $$v)
      },
      expression: "lCat.task_cat"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChangesCat($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lMAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    on: {
      "click": function($event) {
        return _vm.deleteCat(_vm.lCat)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.manageTaskLoc),
      callback: function($$v) {
        _vm.manageTaskLoc = $$v
      },
      expression: "manageTaskLoc"
    }
  }, [_c('v-form', [(_vm.lLAction === 'view') ? _c('v-card', {
    attrs: {
      "flat": "",
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4 py-0"
  }, [_vm._v("\n        Task Location\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.manageTaskLoc = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "accent",
      "flat": ""
    },
    on: {
      "click": _vm.createManageLoc
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.ManageLocHead,
      "items": _vm.locList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditLoc(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.task_loc))])])]
      }
    }], null, false, 2302749254)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lLAction === 'create' || _vm.lLAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "acForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveTaskLoc(_vm.lLAction)
      }
    }
  }, [_c('v-card', {
    staticClass: "pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          " + _vm._s(_vm.handy.startWithUpper(_vm.lLAction)) + " Task Location\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Location name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lLoc.task_loc),
      callback: function($$v) {
        _vm.$set(_vm.lLoc, "task_loc", $$v)
      },
      expression: "lLoc.task_loc"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChangesLoc($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lLAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    on: {
      "click": function($event) {
        return _vm.deleteLoc(_vm.lLoc)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.lAction === 'view-bucket') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "mx-auto": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Available Task Bucket")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.bucketHeader,
      "items": _vm.bucketList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareImportBucket(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.task_bucket_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.tot_bucket_task))])])]
      }
    }], null, false, 2653400162)
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareUpload($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "accent"
    }
  }, [_vm._v("file_upload")]), _vm._v("Upload")], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "width": "900px"
    },
    model: {
      value: (_vm.showImportBucketList),
      callback: function($$v) {
        _vm.showImportBucketList = $$v
      },
      expression: "showImportBucketList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text pa-1"
  }, [_vm._v(_vm._s('Bucket Name: ' + _vm.bucketImportList[0].task_bucket_name))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.loadBucketImportHead,
      "items": _vm.bucketImportList,
      "select-all": "",
      "hide-actions": "",
      "item-key": "task_bucket_det_id"
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_c('v-checkbox', {
          attrs: {
            "input-value": props.all,
            "indeterminate": props.indeterminate,
            "primary": "",
            "hide-details": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.toggleAll($event)
            }
          }
        })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            staticClass: "text-xs-left"
          }, [_vm._v("\n          " + _vm._s(header.text) + "\n        ")])
        })], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "input-value": props.selected,
            "primary": "",
            "hide-details": ""
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.task_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.proj_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.task_desc))]), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-btn', {
          staticClass: "mr-0",
          attrs: {
            "icon": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.prepareUpdateTaskInBucket(props.item)
            }
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteTaskInBucket(props.item)
            }
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showImportBucketList = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent",
      "disabled": !_vm.selected.length
    },
    on: {
      "click": _vm.importToTask
    }
  }, [_vm._v("Import to task")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showEditBucket),
      callback: function($$v) {
        _vm.showEditBucket = $$v
      },
      expression: "showEditBucket"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text pa-1"
  }, [_vm._v("Update Task")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.catList,
      "label": "Task Category",
      "item-text": "task_cat",
      "item-value": "task_cat_id",
      "return-object": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.findCat(_vm.lImportList)
      }
    },
    model: {
      value: (_vm.lImportList.task_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lImportList, "task_cat_pair", $$v)
      },
      expression: "lImportList.task_cat_pair"
    }
  })], 1), _vm._v(" "), (_vm.lImportList.task_cat === 'Project') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Project Name",
      "rules": [_vm.rules.required],
      "maxlength": "25",
      "hide-details": ""
    },
    model: {
      value: (_vm.lImportList.proj_name),
      callback: function($$v) {
        _vm.$set(_vm.lImportList, "proj_name", $$v)
      },
      expression: "lImportList.proj_name"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.cats,
      "label": "Service",
      "item-text": "comp_cat",
      "item-value": "comp_cat_id",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lImportList.task_service),
      callback: function($$v) {
        _vm.$set(_vm.lImportList, "task_service", $$v)
      },
      expression: "lImportList.task_service"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Task description",
      "rows": "2",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "250"
    },
    model: {
      value: (_vm.lImportList.task_desc),
      callback: function($$v) {
        _vm.$set(_vm.lImportList, "task_desc", $$v)
      },
      expression: "lImportList.task_desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showEditBucket = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.saveUpdatedTask
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.showAssignedUser),
      callback: function($$v) {
        _vm.showAssignedUser = $$v
      },
      expression: "showAssignedUser"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 title"
  }, [_vm._v("\n      Eligible Assignees\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showAssignedUser = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-2",
    attrs: {
      "headers": _vm.AssignedUserHeader,
      "items": _vm.mcList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.user_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user_name))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "940px"
    },
    model: {
      value: (_vm.showCheckList),
      callback: function($$v) {
        _vm.showCheckList = $$v
      },
      expression: "showCheckList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'title py-0 grey lighten-4' : 'title pa-2 grey lighten-4'
  }, [_vm._v("\n      " + _vm._s('Checklist: ' + _vm.lCl.task_cat + ' - ' + _vm.lCl.service) + " "), _c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s('(Task #' + _vm.lCl.task_id + ')'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showCheckList = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs6": ""
    }
  }, [(_vm.lCl.tot_cl) ? _c('span', {
    staticClass: "subheading info--text"
  }, [_vm._v(_vm._s(_vm.lCl.tot_completed_cl + '/' + _vm.lCl.tot_cl) + " completed")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "flat": "",
      "small": "",
      "disabled": _vm.lCl.task_status === 'Completed'
    },
    on: {
      "click": _vm.prepareCreateCl
    }
  }, [_vm._v("Add Item")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "tblChecklist elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.clHeader : _vm.clHeaderSm,
      "items": _vm.clList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.dragElement()
            }
          }
        }, [_c('v-icon', [_vm._v("zoom_out_map")])], 1), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_c('v-checkbox', {
          attrs: {
            "hide-details": "",
            "disabled": _vm.lCl.task_status === 'Completed' ? true : false
          },
          on: {
            "change": function($event) {
              return _vm.saveTaskClChanges(props.item)
            }
          },
          model: {
            value: (props.item.is_cl_completed),
            callback: function($$v) {
              _vm.$set(props.item, "is_cl_completed", $$v)
            },
            expression: "props.item.is_cl_completed"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          style: (props.item.is_cl_completed ? 'text-decoration: line-through;' : '')
        }, [_vm._v(_vm._s(props.item.cl_item))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3",
          style: (props.item.is_cl_completed ? 'text-decoration: line-through;' : '')
        }, [_vm._v(_vm._s(props.item.cl_created_by + ' on ' + _vm.handy.formatDate(props.item.cl_created_on) + ' ' + _vm.handy.getTime12Hrs(props.item.cl_created_on)))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3",
          style: (props.item.is_cl_completed ? 'text-decoration: line-through;' : '')
        }, [_vm._v(_vm._s(props.item.cl_last_updated_by ? props.item.cl_last_updated_by + ' on ' + _vm.handy.formatDate(props.item.cl_last_updated_on) + ' ' + _vm.handy.getTime12Hrs(props.item.cl_last_updated_on) : '-'))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0 py-2"
        }, [_c('v-btn', {
          staticClass: "mr-0",
          attrs: {
            "icon": "",
            "small": "",
            "disabled": (_vm.lCl.task_status === 'Completed' ? true : props.item.is_cl_completed)
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.prepareUpdateChecklist(props.item)
            }
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": "",
            "disabled": (_vm.lCl.task_status === 'Completed' ? true : props.item.is_cl_completed)
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteTaskChecklist(props.item)
            }
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.clDownloadHeader,
      "items": _vm.clDownloadList,
      "title": "Task checklist"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showCl),
      callback: function($$v) {
        _vm.showCl = $$v
      },
      expression: "showCl"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "clForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveClChanges($event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          " + _vm._s(this.lChecklist.lAction === 'create' ? 'Create' : 'Update') + " checklist\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Item",
      "rules": [_vm.rules.required],
      "maxlength": "150",
      "hide-details": ""
    },
    model: {
      value: (_vm.lChecklist.cl_item),
      callback: function($$v) {
        _vm.$set(_vm.lChecklist, "cl_item", $$v)
      },
      expression: "lChecklist.cl_item"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCl = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticClass: "text-xs-center mt-5"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-bf282820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Task.vue
// module id = 864
// module chunks = 3